import { useTranslation } from 'react-i18next';

import type { LiveGameInfo } from '@/types/qriots';

interface LiveGameBannerProps {
  data: LiveGameInfo;
  viewerPuuid: string;
}

function formatGameLength(secondsTotal: number): string {
  const m = Math.floor(secondsTotal / 60);
  const s = secondsTotal % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function LiveGameBanner({ data, viewerPuuid }: LiveGameBannerProps) {
  const { t } = useTranslation('riot');
  const viewer = [...data.blueTeam, ...data.redTeam].find((p) => p.puuid === viewerPuuid);
  const queue = data.gameQueueLabel ?? data.gameMode;

  const headline = data.inChampSelect
    ? t('live.inChampSelect', { queue })
    : t('live.inGame', { queue, duration: formatGameLength(data.gameLength) });

  return (
    <div className="mx-4 flex items-center gap-3 rounded-xl border border-danger/30 bg-danger/10 p-3 text-sm">
      <span className="h-2 w-2 shrink-0 animate-pulse rounded-full bg-danger" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-danger">{headline}</p>
        {viewer && (
          <p className="truncate text-xs text-fg">
            {viewer.riotId ?? '—'} · {viewer.championName ?? `Champion ${viewer.championId}`}
          </p>
        )}
      </div>
    </div>
  );
}
